/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DistrictResponseDto } from './districtResponseDto';
import { MemberTierResponseTabletDto } from './memberTierResponseTabletDto';
import { ProvinceResponseDto } from './provinceResponseDto';
import { SubDistrictResponseDto } from './subDistrictResponseDto';

export interface MemberResponseTabletDto {
  id: string;
  name: string;
  firstname: string;
  lastname: string;
  entityType: MemberResponseTabletDto.EntityTypeEnum;
  address: string;
  province: ProvinceResponseDto;
  district: DistrictResponseDto;
  subDistrict: SubDistrictResponseDto;
  zipCode: string;
  email: string;
  imageUrl: string;
  phone: string;
  memberTier: MemberTierResponseTabletDto;
  memberNo: string;
  noOfBank: number;
}
// tslint:disable-next-line:no-namespace
export namespace MemberResponseTabletDto {
  export type EntityTypeEnum = 'individual' | 'corporate';
  export const EntityTypeEnum = {
      Individual: 'individual' as EntityTypeEnum,
      Corporate: 'corporate' as EntityTypeEnum,
  };
}
